(() => {
    let sendingJsError = false;

    const scriptTag = document.getElementById('error-reporting-script')!;
    const appMode = scriptTag.getAttribute('data-app-mode')! as string;
    const isCrawler = scriptTag.getAttribute('data-is-crawler')! as string;

    // @ts-ignore
    function reportError(errorMsg, errorUrl, errorLineNumber, errorColumn, errorObj)
    {
        if (sendingJsError) {
            return;
        }

        if (isCrawler === 'true') {
            return;
        }

        const isXOriginRequestSecurityError = errorMsg.toLowerCase().indexOf('script error') !== -1
        if (isXOriginRequestSecurityError) {
            return;
        }

        const data = new FormData();
        data.append("errorMsg", errorMsg);
        data.append("errorUrl", errorUrl);
        data.append("errorLineNumber", errorLineNumber);
        data.append("errorColumn", errorColumn);
        data.append("errorLocation", window.location.href);
        data.append("errorObj", errorObj.stack || errorObj);

        sendingJsError = true;

        fetch(
            '/errorReport/api_frontend_js_error/',
            {
                method: "POST",
                headers: {
                    "X-Requested-With": "XMLHttpRequest"
                },
                credentials: 'same-origin',
                body: data,
            })
            .catch((error) => {
                // do nothing if fetch itself fails
            })
            .finally(() => {
                sendingJsError = false;
            });
    }


    window.onerror = function (errorMsg, errorUrl, errorLineNumber, errorColumn, errorObj) {
        if (errorObj && !isErrorRelevant(errorObj)) {
            return;
        }

        reportError(errorMsg, errorUrl, errorLineNumber, errorColumn, errorObj);
    };

    window.addEventListener('unhandledrejection', function(event) {
        const reason = event.reason

        if (! (reason instanceof Error)) {
            return;
        }

        if (! isErrorRelevant(reason)) {
            return;
        }

        reportError(
            reason.message,
            // @ts-ignore
            reason.url?.toString() || '',
            // @ts-ignore
            reason.lineNumber?.toString() || '',
            // @ts-ignore
            reason.column?.toString() || '',
            reason.stack
        );
    });

    /**
     * Skip known errors, which won't be fixed atm
     */
    function isErrorRelevant(error: Error): boolean
    {
        if (error.message.toLowerCase().indexOf('networkerror when attempting to fetch resource') !== -1) {
            return false;
        }

        if (error.message.indexOf('Object.prototype.hasOwnProperty.call(e,"telephone")') !== -1) {
            return false;
        }

        if (error.message.toLowerCase().indexOf('the operation was aborted') !== -1) {
            return false;
        }

        // Cookiefirst must error only in production
        if (error.message.toLowerCase().indexOf('failed to load configs') !== -1) {
            if (appMode !== 'production') {
                return false;
            }

            return true;
        }

        return true;
    }

})();
